/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'fabric.atlassianSwitcher.administration': 'Administración',
  'fabric.atlassianSwitcher.analytics': 'Análisis',
  'fabric.atlassianSwitcher.assets': 'Activos',
  'fabric.atlassianSwitcher.atlassianHome': 'Inicio',
  'fabric.atlassianSwitcher.atlassianWebsiteTryProducts': 'Probar productos de Atlassian',
  'fabric.atlassianSwitcher.autoProvConfluenceUiUpdateExperimentDescription': 'Colaboración en documentos',
  'fabric.atlassianSwitcher.chat': 'Chat',
  'fabric.atlassianSwitcher.companyHub': 'Centro empresarial',
  'fabric.atlassianSwitcher.confluenceDescriptionText': 'Documentación y colaboración',
  'fabric.atlassianSwitcher.confluenceSpace': 'Espacio de Confluence',
  'fabric.atlassianSwitcher.emptyState.exploreProducts.body':
    'Prueba un producto para empezar a colaborar con tu equipo.',
  'fabric.atlassianSwitcher.emptyState.exploreProducts.link': 'Explorar productos',
  'fabric.atlassianSwitcher.emptyState.exploreProducts.title': 'Empezar a usar Cloud',
  'fabric.atlassianSwitcher.errorEmptyPartialResults': 'No se pueden mostrar tus aplicaciones en este momento.',
  'fabric.atlassianSwitcher.errorFlag.description':
    'Vuelve a intentarlo dentro de unos minutos. Si sigues sin poder unirte, <a>ponte en contacto con el servicio de soporte</a>.',
  'fabric.atlassianSwitcher.errorFlag.title': 'No hemos podido añadirte a {product}',
  'fabric.atlassianSwitcher.errorHeading': 'Algo ha ido mal',
  'fabric.atlassianSwitcher.errorHeadingLoggedOut': 'Tu cuenta de Atlassian está desconectada',
  'fabric.atlassianSwitcher.errorHeadingUnverified': 'La cuenta no está verificada',
  'fabric.atlassianSwitcher.errorImageAltText': 'Un robot estropeado y varias personas arreglándolo.',
  'fabric.atlassianSwitcher.errorPartialResults': 'No se pueden mostrar algunas de tus aplicaciones en este momento.',
  'fabric.atlassianSwitcher.errorPartialResultsRefresh': 'Actualiza la página o vuelve a intentarlo más tarde.',
  'fabric.atlassianSwitcher.errorText':
    'Aunque nos encargamos de supervisar estos errores, no dudes en contactar con nosotros si se repiten después de actualizar la página.',
  'fabric.atlassianSwitcher.errorTextLoggedOut': 'Vuelve a iniciar sesión para utilizar el alternador de Atlassian.',
  'fabric.atlassianSwitcher.errorTextNetwork':
    'No hemos podido cargar esta lista. Vuelve a cargar la página e inténtalo de nuevo.',
  'fabric.atlassianSwitcher.errorTextUnverified':
    'Confirma tu dirección de correo electrónico para ver una lista de los productos disponibles.',
  'fabric.atlassianSwitcher.goals': 'Metas',
  'fabric.atlassianSwitcher.home': 'Atlassian Home',
  'fabric.atlassianSwitcher.instantAccessStatusText': 'Acceso instantáneo',
  'fabric.atlassianSwitcher.jiraDescriptionText': 'Planificar y realizar un seguimiento de la entrega del proyecto',
  'fabric.atlassianSwitcher.jiraProject': 'Proyecto Jira',
  'fabric.atlassianSwitcher.join': 'Unirse',
  'fabric.atlassianSwitcher.joinStatusText': 'Unirse',
  'fabric.atlassianSwitcher.joinTeamStatusText': 'Unirse al equipo',
  'fabric.atlassianSwitcher.jpdDescriptionText': 'Priorizar y planificar nuevas ideas',
  'fabric.atlassianSwitcher.jsmDescriptionText': 'Automatiza y ofrece asistencia de TI',
  'fabric.atlassianSwitcher.jwmInactiveSwitcherWithDefaultItemDescription':
    'Gestiona proyectos para equipos empresariales.',
  'fabric.atlassianSwitcher.jwmInactiveSwitcherWithJSWItemDescription':
    'Gestiona proyectos empresariales de forma gratuita con Jira Software.',
  'fabric.atlassianSwitcher.login': 'Iniciar sesión',
  'fabric.atlassianSwitcher.manageList': 'Administrar lista',
  'fabric.atlassianSwitcher.modalLabel': 'Intercambiador de aplicaciones de Atlassian',
  'fabric.atlassianSwitcher.more': 'Más',
  'fabric.atlassianSwitcher.newLozenge': 'Novedad',
  'fabric.atlassianSwitcher.organisationsLabel': 'Organizaciones',
  'fabric.atlassianSwitcher.product.description.compass': 'Gestor de componentes',
  'fabric.atlassianSwitcher.product.description.confluence': 'Colaboración en documentos',
  'fabric.atlassianSwitcher.product.description.jsm': 'Gestión de servicios de TI de colaboración',
  'fabric.atlassianSwitcher.product.description.jsw': 'Seguimiento de proyectos e incidencias',
  'fabric.atlassianSwitcher.product.description.opsgenie': 'Gestión de incidentes moderna',
  'fabric.atlassianSwitcher.requestAccessStatusText': 'Solicitar acceso',
  'fabric.atlassianSwitcher.requestSentStatusText': 'Solicitud enviada',
  'fabric.atlassianSwitcher.resizeBarLabel': '"Expandir" o "Contraer" dependiendo del estado',
  'fabric.atlassianSwitcher.resizeBarTooltipCollapsed': 'Arrastra para cambiar el tamaño{separator}Pulsa para ampliar',
  'fabric.atlassianSwitcher.resizeBarTooltipExpanded': 'Arrastra para cambiar el tamaño{separator}Pulsa para contraer',
  'fabric.atlassianSwitcher.resizeBarValueTextLabel': 'Ancho',
  'fabric.atlassianSwitcher.search': 'Buscar',
  'fabric.atlassianSwitcher.sites': '{numSites, plural, one {{productName} sitio} other {{productName} sitios}}',
  'fabric.atlassianSwitcher.skeletonLoaderAriaLabel': 'El Intercambiador de aplicaciones se está cargando',
  'fabric.atlassianSwitcher.start': 'Inicio de Atlassian',
  'fabric.atlassianSwitcher.startAriaLabel': 'Inicio de Atlassian se abre en una nueva pestaña',
  'fabric.atlassianSwitcher.studio': 'Estudio',
  'fabric.atlassianSwitcher.successFlag.description': 'Recibirás un correo electrónico cuando se haya aprobado',
  'fabric.atlassianSwitcher.successFlag.title': 'Solicitud de acceso enviada al administrador',
  'fabric.atlassianSwitcher.switchSitesOrAppsTooltip': 'Cambiar sitios o aplicaciones',
  'fabric.atlassianSwitcher.switchTo': 'Cambiar a',
  'fabric.atlassianSwitcher.switchToTooltip': 'Cambiar a…',
  'fabric.atlassianSwitcher.teams': 'Equipos',
  'fabric.atlassianSwitcher.tryLozenge': 'Pruébalo',
  'fabric.atlassianSwitcher.yourApps': 'Tus aplicaciones',
  'fabric.atlassianSwitcher.yourAppsTooltip': 'Tus aplicaciones…',
};
